var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756383162490,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 37712,
    width: 18,
    height: 18,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M914.285714 548.571429q0 30.857143-21.142857 52l-372 372q-22.285714 21.142857-52 21.142857-29.142857 0-51.428571-21.142857l-42.857143-42.857143q-21.714286-21.714286-21.714286-52t21.714286-52l167.428571-167.428571-402.285714 0q-29.714286 0-48.285714-21.428571t-18.571429-51.714286l0-73.142857q0-30.285714 18.571429-51.714286t48.285714-21.428571l402.285714 0-167.428571-168q-21.714286-20.571429-21.714286-51.428571t21.714286-51.428571l42.857143-42.857143q21.714286-21.714286 51.428571-21.714286 30.285714 0 52 21.714286l372 372q21.142857 20 21.142857 51.428571z",
    "p-id": 37713,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyArrowRight);
export default __webpack_public_path__ + "static/media/my-arrow-right.030c2b28.svg";
export { ForwardRef as ReactComponent };